<template v-if="copy">
  <p :class="[name]">
    {{ copy }}
  </p>
</template>

<script>
import data from '~/components/atoms/a-eyebrow/a-eyebrow.data'

export default {
  props: {
    cms: {
      type: Object,
      default() {
        return Object.assign(process.env.NODE_ENV === 'development' ? data : {})
      },
    },
  },
  data() {
    return {
      name: 'a-eyebrow',
    }
  },
  computed: {
    copy() {
      return this.cms.eyebrow
    },
  },
}
</script>

<style lang="scss" scoped>
.a-eyebrow {
  font-size: 12px;
  letter-spacing: 1px;
  min-height: 26px;
}
</style>
